import { Rotate as OLRRotate } from 'ol/control';
import { default as RControlBase } from './RControlBase';
/**
 * A rotation control for mobile devices
 *
 * Requires an `RMap` context
 */
export default class RRotate extends RControlBase {
    constructor(props, context) {
        super(props, context);
        this.ol = new OLRRotate(this.toOLProps(props));
    }
    toOLProps(props) {
        return Object.assign(Object.assign({}, super.toOLProps(props)), { label: props.label, autoHide: props.autoHide });
    }
}
//# sourceMappingURL=RRotate.js.map